import React, { PureComponent } from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
export default class MyPieChart extends PureComponent {
        constructor(props) {
                super(props)
                this.state = {
                        data: props.data
                }
        }
        render() {
                return (
                        <div style={{ width: '100%', height: 235 }}>
                                <ResponsiveContainer>
                                        <PieChart>
                                                <Pie dataKey="value" 
                                                        data={this.props.data} 
                                                        outerRadius={60} 
                                                        fill="#8884d8" 
                                                        label 
                                                        paddingAngle={0}>
                                                        {this.props.data.map((entry, index) => (
                                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                        ))}
                                                </Pie>
                                                <Tooltip />
                                                <Legend/>
                                        </PieChart>
                                </ResponsiveContainer>
                        </div>
                );
        }
}
